enum CommentStatus {
  MODERATION = 0,
  PUBLISHED = 1,
  DELETED_BY_USER = 2,
  DELETED_BY_ADMIN = 3,
  BANNED = 4,
}

export default CommentStatus
